'use client';

import { useSearchStateReset } from '@/hooks/useSearchStateReset';

interface SearchStateResetProviderProps {
  children: React.ReactNode;
}

export function SearchStateResetProvider({ children }: SearchStateResetProviderProps) {
  useSearchStateReset();
  
  return <>{children}</>;
}